import React, { useState, useEffect } from "react";
import { Link } from "@reach/router";
import { LoadingModal } from "../ui/Modals";
import { useContractContext } from "../../hooks/useContractContext";

const NavLink = (props) => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: isCurrent ? "active" : "non-active",
      };
    }}
  />
);

// converted from class component to functional component
export const ViewArtwork = (props) => {
  const { copyrightsContract,  } = useContractContext();

  const [smartContractData, setSmartContractData] = useState([]);

  const [nftData, setNftData] = useState({
    nfts: [].slice(0, 8),
    height: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      // ======================== PULL SMART CONTRACT DATA FROM ETHERUEM ========================//
      const numTokens = Number(await copyrightsContract.totalSupply());
      const tempArray = [numTokens - 1];

      for (let index = 0; index < numTokens; index++) {
        const tokenId = copyrightsContract.tokenByIndex(index);
        const tokenWorkDetails = await copyrightsContract.checkDetailsOfWork(
          tokenId
        );
        tempArray[index] = { tokenWorkDetails, tokenId };
      }
      // save data into a constant that can be passed to other components
      setSmartContractData(tempArray);

      setNftData((prevState) => ({
        ...prevState,
        nfts: tempArray.slice(0, 8),
      }));
    };
    fetchData();
  }, [copyrightsContract]);

  function loadMore() {
    const nftState = nftData.nfts;
    const end = nftState.length + 4;
    setNftData((prevState) => ({
      ...prevState,
      nfts: smartContractData.slice(0, end),
    }));
  }

  function onImgLoad({ target: img }) {
    let currentHeight = nftData.height;
    if (currentHeight < img.offsetHeight) {
      setNftData((prevState) => ({ ...prevState, height: img.offsetHeight }));
    }
  }

  function formatIpfsUrl(url) {
    return url.replace(/ipfs:\/\//g, "https://nftstorage.link/");
  }

  return (
    <div className="row">
      {smartContractData.length === 0 && (
        <LoadingModal title={"Loading Data..."} />
      )}
      {nftData &&
        nftData.nfts.map((copyrightsAsset, tokenId) => (
          <div
            key={tokenId}
            className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-4"
          >
            <div className="nft__item m-0">
              <div
                className="nft__item_wrap"
                style={{ height: `${nftData.height}px` }}
              >
                <span>
                  <NavLink to={`/ViewItem/${tokenId}`}>
                    <img
                      onLoad={onImgLoad}
                      src={formatIpfsUrl(
                        copyrightsAsset.tokenWorkDetails.workIpfsCid
                      )}
                      className="lazy nft__item_preview"
                      alt=""
                    />
                  </NavLink>
                </span>
              </div>
            </div>
          </div>
        ))}
      {nftData && nftData.nfts.length !== smartContractData.length && (
        <div className="col-lg-12">
          <div className="spacer-single"></div>
          <span onClick={() => loadMore()} className="btn-main lead m-auto">
            Load More
          </span>
        </div>
      )}
    </div>
  );
};

export default ViewArtwork;
